import { render, staticRenderFns } from "./VSalaryDiscountsView.vue?vue&type=template&id=5db6594e&"
import script from "./VSalaryDiscountsView.vue?vue&type=script&lang=js&"
export * from "./VSalaryDiscountsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VDataTable})
